import Vue from "vue";
import userService from "../../services/user/user";
import authService from "../../services/authentication/authentication";
import { User } from "../../services/user/entities/user.interface";
import { UserState } from "./states/user.state.interface";

export default {
  namespaced: true,
  state: {
    users: []
  },
  getters: {
    getUsers: (state: UserState) => state.users
  },
  mutations: {
    setUsers(state: UserState, users: Array<User>) {
      Vue.set(state, "users", users);
    }
  },
  actions: {
    getUsers: async (context: any) => {
      await userService.getUsers().then((response: any) => {
        context.commit("setUsers", response.data.users);
      });
    },
    createUser: async (context: any, payload: any) => {
      let created = false;
      await userService.createUser(payload).then(async (response: any) => {
        created = response.data.created;
        await authService.sendEmailToChangePassword({ email: payload.email });
        await userService.getUsers().then((response: any) => {
          context.commit("setUsers", response.data.users);
        });
      });
      return created;
    },
    updateUser: async (context: any, payload: any) => {
      let updated = false;
      await userService.updateUser(payload).then(async (response: any) => {
        updated = response.data.updated;
        await userService.getUsers().then((response: any) => {
          context.commit("setUsers", response.data.users);
        });
      });
      return updated;
    },
    deleteUser: async (context: any, payload: any) => {
      let deleted = false;
      await userService.deleteUser(payload).then(async (response: any) => {
        deleted = response.data.deleted;
        await userService.getUsers().then((response: any) => {
          context.commit("setUsers", response.data.users);
        });
      });
      return deleted;
    }
  }
};
